/** Hover/selected styles for outline toggle chips (time range, segment picker, scope bars). */
export const OUTLINE_TOGGLE_CHIP_CLASSNAME =
  'border-border! hover:z-10 hover:border-white! hover:text-white! data-[state=on]:bg-secondary! data-[state=on]:text-white!';
